import React from "react";
import classNames from "classnames";

const InfoBox = ({ icon, text, variant = "info", className, onClick }) => {
    return (
        <div className={classNames("info__lmf", `info__lmf--${variant}`, className)} onClick={onClick}>
            <div className="info__lmf--icon">
                {typeof icon === "string" ? (
                    <img src={icon} alt="icon" />
                ) : (
                    icon
                )}
            </div>
            <div className="info__lmf--content" dangerouslySetInnerHTML={{ __html: text }}></div>
        </div>
    );
};

export default InfoBox;
